import { render } from "./TakeAwayPageBody.vue?vue&type=template&id=ff6de38c"
import script from "./TakeAwayPageBody.vue?vue&type=script&lang=js"
export * from "./TakeAwayPageBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__